import { render, staticRenderFns } from "./ElementMenu.vue?vue&type=template&id=4c56a3f8"
import script from "./ElementMenu.vue?vue&type=script&lang=js"
export * from "./ElementMenu.vue?vue&type=script&lang=js"
import style0 from "./ElementMenu.vue?vue&type=style&index=0&id=4c56a3f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports